<template>
  <dropdown-menu v-on="$listeners" item-key-text="text" :items="items">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on">
        <v-btn
          data-test="openCardActions"
          max-height="36"
          max-width="36"
          icon
          :color="color"
          v-on="on"
          :class="activatorClass"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </slot>
    </template>
  </dropdown-menu>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';

export default {
  name: 'AppEntityToolbarMenu',
  components: {
    DropdownMenu
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    color: {
      type: String
    },
    activatorClass: {
      type: [String, Array, Object]
    }
  }
};
</script>

<style lang="sass" scoped>
.shadow
    background-color: rgba(255, 255, 255, 0.44) !important
    border-color: rgba(255, 255, 255, 0.44) !important
</style>
